import React from 'react';
import PropTypes from 'prop-types';

import ExportButton from '../ExportButton.jsx';

// =============================================================================
// BLOCK EOOT.1 — Export Outstanding Orders TMS Component
// Handles CSV export for outstanding orders from the TMS table
// =============================================================================
function ExportOutstandingOrdersTMS({ searchText, hideCompletedOrders }) {
  // BLOCK EOOT.1.1 — Always use all-reps endpoint
  const url = '/api/outstanding-orders-tms/all-reps';
  const filename = 'outstanding-orders-tms-all-reps.csv';

  // BLOCK EOOT.1.2 — Build query parameters
  const params = new URLSearchParams();
  if (searchText) {
    params.append('search', searchText);
  }
  if (hideCompletedOrders) {
    params.append('hideCompletedOrders', 'true');
  }
  const fullUrl = params.toString() ? `${url}?${params.toString()}` : url;

  // BLOCK EOOT.1.3 — Render export button
  return (
    <ExportButton
      url={fullUrl}
      filename={filename}
      data-cy="export-outstanding-orders-tms-button"
      buttonText="Export CSV"
    />
  );
}

ExportOutstandingOrdersTMS.propTypes = {
  searchText: PropTypes.string,
  hideCompletedOrders: PropTypes.bool,
};

ExportOutstandingOrdersTMS.defaultProps = {
  searchText: '',
  hideCompletedOrders: false,
};

export default React.memo(ExportOutstandingOrdersTMS);
